import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSpaceSidebarNotifications } from "@circle-react/hooks/useSpaceSidebarNotifications";
import { useEffect } from "react";

import { useIsMemberAreaAppShellEnabled } from "@/react/hooks/useIsMemberAreaAppShellEnabled";

import { ErrorBoundary } from "../../shared/ErrorBoundary";
import type { SpaceGroupWithSpaces } from "../Sidebar";
import { FooterSection } from "./FooterSection";
import { LinksSection } from "./LinksSection";
import { PlatformMenuSection } from "./PlatformMenuSection";
import { SidebarLayout } from "./SidebarLayout";
import { SidebarV3ErrorFallback } from "./SidebarV3ErrorFallback";
import { SpaceGroupsSection } from "./SpaceGroupsSection";

export interface SidebarV3Props {
  spaceGroupWithSpaces: SpaceGroupWithSpaces[];
}

export const SidebarV3 = ({ spaceGroupWithSpaces }: SidebarV3Props) => {
  const { currentCommunityMember, data } = usePunditUserContext();
  const isMemberAreaAppShellEnabled = useIsMemberAreaAppShellEnabled();
  const { refetchSpaceNotifications } = useSpaceSidebarNotifications();

  useEffect(() => {
    if (currentCommunityMember?.id) {
      void refetchSpaceNotifications();
    }
  }, [currentCommunityMember?.id, refetchSpaceNotifications]);

  const shouldShowCommunityMenuItems =
    !!currentCommunityMember || data?.current_community?.is_private === false;

  return (
    <ErrorBoundary name="SidebarV3" fallback={SidebarV3ErrorFallback}>
      <SidebarLayout
        footer={
          shouldShowCommunityMenuItems &&
          !isMemberAreaAppShellEnabled && <FooterSection />
        }
      >
        <PlatformMenuSection />
        {shouldShowCommunityMenuItems && (
          <>
            <SpaceGroupsSection spaceGroupWithSpaces={spaceGroupWithSpaces} />
            <LinksSection />
          </>
        )}
      </SidebarLayout>
    </ErrorBoundary>
  );
};
